import React from "react";
import { InputGroup } from "react-bootstrap";
import { FormControl } from "../formgroup/FormgroupPage";

function InputgroupPage (props) {

    return (
           <InputGroup className={props?.className}>
            <FormControl placeholder={props?.placeholder} value={props?.value} name={props?.name} type={props?.type} onChange={props?.onChange} error={props?.error}/>
            <InputGroup.Text
                    onClick={props?.onClick}
                  >
                    <img
                      src={props?.src}
                      height="25"
                      width="25"
                      alt="images"
                    ></img>
                  </InputGroup.Text>
           </InputGroup>
    )
}
export default InputgroupPage;

